import { Component } from "react";
import Loading from "./Loading";

class Jws extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      isLoading: true,
    };
  }

  componentDidMount() {
    fetch("https://jadwal-shalat-api.herokuapp.com/monthly?month=2022-06&cityId=53")
      .then((response) => response.json())
      .then((data) =>
        this.setState({
          items: data,
          isLoading: false,
        })
      );
  }

  render() {
    const { items, isLoading } = this.state;
    return <div>{items.data.map((item, index) => console.log(item.date))}</div>;
  }
}

export default Jws;
